import { render } from "./Configs.vue?vue&type=template&id=24bfcefc&scoped=true"
import script from "./Configs.vue?vue&type=script&lang=js"
export * from "./Configs.vue?vue&type=script&lang=js"

import "./Configs.vue?vue&type=style&index=0&id=24bfcefc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bfcefc"],['__file',"src/common/SmartTable/Configs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24bfcefc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24bfcefc', __exports__)) {
    api.reload('24bfcefc', __exports__)
  }
  
  module.hot.accept("./Configs.vue?vue&type=template&id=24bfcefc&scoped=true", () => {
    api.rerender('24bfcefc', render)
  })

}


export default __exports__